<template>
  <vue-draggable-resizable drag-handle=".ant-card-head" class="wrap attrDragDialog dy3dDialog" :w="dragW" :h="dragH" :onResize='onResize' v-if="visible">
    <a-card class="detail-result">
      <span slot="title">{{ detailTitle }}</span>
      <!-- <a-icon slot="extra" type="close" @click.stop="close"/> -->
      <div class="boxClose">
        <img :src="require('@/assets/images/poscloseIcon.png')" style="cursor: pointer" @click.stop="close()" />
      </div>
      <a-descriptions bordered size="small" :column="1">
          <template v-for="(item,index) in detailInfo">
            <a-descriptions-item :label="item.type == 'mvt'? item.alias : (item.key ? item.key : item.alias)" :key="index">
              {{ item.type == 'mvt'? item.value : (item.value ? item.value : item.alias) }}
            </a-descriptions-item>
          </template>
      </a-descriptions>
    </a-card>
  </vue-draggable-resizable>
</template>

<script>

export default {
  name: 'MapDetailInfo',
  components: {
  },
  props: {
  },
  data() {
    return {
      visible: false,
      dragW: 500,
      dragH: 478,
      layerName: '',
      detailTitle: '属性查看',
      detailInfo: []
    }
  },
  mounted () {
  },
  methods: {
    // 弹框缩放中事件
    onResize(handle, x, y, width, height){
      if(width < 300 || height < 200){
        return false
      }
    },
    openDetail (detailInfo, detailTitle) {
      // console.log('属性弹框',detailInfo,detailTitle);
      this.detailInfo = []
      if(detailInfo){
        this.visible = true
        this.detailTitle = detailTitle || '属性查看'
        detailInfo.map(item => {
          if(item.show){
            this.detailInfo.push(item)
          }
        })
        // console.log(this.detailInfo,this.defaultInfo);
      }else{
        this.$message.warning('该图层没有属性')
      }
    },
    close () {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.wrap{
  margin-top: 12px;
  border: none;
  backdrop-filter: blur(15px);
  padding: 0 !important;
  /deep/.handle {
    width: 20px;
    border-radius: 10px;
    height: 20px;
    background: rgba(240, 240, 240, 0.6);
    border: 1px solid #ccc;
    z-index: 2;
  }
}
.detail-result{
  width: 100%;
  height: 100%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  .boxClose {
    position: absolute;
    top: 2%;
    right: 2%;
  }
  /deep/.ant-card-head{
    min-height: 40px;
    padding: 0;
    margin: 0 2.5%;
    cursor: all-scroll;
    background: transparent;
    border-bottom: 1px solid rgba(255,255,255,0.2);
    .ant-card-head-title,.ant-card-extra{
      padding: 8px 3px;
    }
  }
  /deep/.ant-card-body{
    padding: 12px;
    // max-height: 300px;
    overflow: auto;
  }
  /deep/.ant-descriptions-item-label, /deep/.ant-descriptions-item-content{
    font-size: 16px;
    word-break: break-all;
    min-width: 100px;
  }
  /deep/.ant-descriptions-item-label {
    color: #fff;
  }
  /deep/.ant-card-extra a{
    font-size: 16px;
  }
}
/deep/.ant-card-head-wrapper{
  background: transparent;
}
/deep/.ant-descriptions-view{
  border: 0;
  border-radius: 0;
}
/deep/.ant-descriptions-bordered .ant-descriptions-item-content{
  border: 1px solid rgba(255, 255, 255, 0.30);
}
/deep/ .ant-descriptions {
  height: 100%;
  overflow: auto;
}
</style>
